// extracted by mini-css-extract-plugin
export default {"nodeItem":"styles_nodeItem__n1F5q","iconContainer":"styles_iconContainer__nZ55f","dragIcon":"styles_dragIcon__4CyAb","description":"styles_description__GRQFk"};